import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { ChecklistWithItemsDto } from 'src/Services/API/generated';

const useFetchExportedChecklist = ({
  token,
  checklistId,
}: {
  token: string;
  checklistId?: string;
}) => {
  return useQuery({
    queryKey: ['fetch-exported-checklist', token, checklistId],
    queryFn: async () => {
      if (!checklistId) throw new Error('No checklist provided');
      return (
        await publicExportsApi.publicChecklistSubmissionsControllerGetPublicChecklistById(
          token,
          checklistId
        )
      ).data as ChecklistWithItemsDto;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: checklistId !== undefined,
  });
};

export default useFetchExportedChecklist;
